import { combineReducers } from "redux";
import user from './user';
import isAuthenticated from './isAuthenticated';

export default combineReducers({ user, isAuthenticated });
